export const NOTES_DEBOUNCE_MS = 2000;

// How long to hold a notes edit before saving. null means no save is needed (the edit rides along with other saves); 0 means save now.
// - Notes that aren't scored don't schedule a save, since the debounce only avoids a revision per keystroke.
// - A pending edit is never held past the time limit, and once the limit has passed the edit is
//   saved immediately so it lands inside the server's grace window instead of after it.
export function notesDebounceMs(
  { scored, timed, timerStartedAt, timeLimitMin },
  now = Date.now(),
) {
  if (!scored) return null;
  if (!timed || !timerStartedAt) return NOTES_DEBOUNCE_MS;
  const limitEnd = new Date(timerStartedAt).getTime() + timeLimitMin * 60000;
  return Math.max(0, Math.min(NOTES_DEBOUNCE_MS, limitEnd - now));
}
